//import React, { useEffect } from 'react';
import '../styles/global_styles.css';
import Header from '../components/Header';
import globalStore from '../store/global';
import MostrarBuscador from '../components/MostrarBuscador';
import Footer from '../components/Footer';

const Buscador = () => {

    const { seccion, setSeccion } = globalStore();

    const navegarA = (destino: string) => {
        setSeccion(destino);
        let seccionElement = document.getElementById(destino);
        if (seccionElement === null) return;
        seccionElement.scrollIntoView({ behavior: 'smooth' });
    };
              
    return (
        <div className="flex flex-col h-screen ">
            <Header navegacionFija={true} seccionActual={'buscador'} cambiarSeccion={navegarA}></Header>
            <div className="bg-white flex flex-col flex-grow">
                <MostrarBuscador />
            </div>
            <Footer id="footer" />
        </div>
    );
};

export default Buscador;